<script>
import TwContainer from '@/components/generic/tw-container.vue'
import TwTabs from '@/components/generic/tabs/tw-tabs.vue'
import { useFundraiserPageStore } from '@/stores/fundraiserPage.js'
import { useFundraiserStore } from '@/stores/fundraiser.js'
import { useAuthStore } from '@/stores/auth.js'
import TwButton from '@/components/generic/tw-button.vue'
import TwPaginator from '@/components/generic/tw-paginator.vue'
import FundraiserCreateModal from '@/components/fundraisers/fundraiser-create-modal.vue'
export default {
  name: 'FundraisersIndexContainerPage',
  components: { FundraiserCreateModal, TwPaginator, TwButton, TwTabs, TwContainer },
  computed: {
    tabs() {
      const tabs = [];
      if(useFundraiserStore().items.length > 0) {
        tabs.push({ name: 'My Fundraisers', count: useFundraiserStore().total , current: this.$route.name === 'FundraisersIndexPage', to: { name: 'FundraisersIndexPage' } })
      }
      if(useFundraiserPageStore().items.length > 0) {
        tabs.push({ name: 'Fundraisers I\'ve Joined', count: useFundraiserPageStore().total, current: this.$route.name === 'MyFundraiserPagesIndexPage', to: { name: 'MyFundraiserPagesIndexPage' } })
      }
      return tabs
    },
    currentUser() {
      return useAuthStore().currentUser
    }
  },
  async mounted() {

  },
  methods: {
    async fundraiserCreated(fundraiser) {
      await this.$router.push({ name: 'FundraiserDetailsPage', params: { fundraiserId: fundraiser.id } })
    }
  }
}
</script>

<template>
  <router-view v-slot="{ Component }">
    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
      <component :is="Component" />
    </transition>
  </router-view>
  <fundraiser-create-modal ref="fundraiserCreateModal" @created="fundraiserCreated" />
</template>

<style scoped>

</style>
